import React, { useEffect, useState } from 'react';
import { Box, Container, makeStyles } from '@material-ui/core';

import Toolbar from './toolbar';
import Results from './results';
import configs from '../../configs';
import Page from '../../components/Page';
import firebaseUtility from '../../utils/firebase.utils';

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    minHeight: '100%',
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3)
  }
}));
const Support = () => {
  const classes = useStyles();
  const [articles, setArticles] = useState([]);
  const [loading, setLoading] = useState(false);
  const [lastItem, setLastItem] = useState(null);
  const [firstItem, setFirstItem] = useState(null);
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(10);

  useEffect(() => {
    (async () => {
      // eslint-disable-next-line no-use-before-define
      await getArticles();
    })();
  }, []);

  const getArticles = async (prev = false, size = pageSize) => {
    setLoading(true);
    let articlesDocs;
    if (prev) {
        articlesDocs = await firebaseUtility.GetPrevPageAllDocuments(
        'support_articles',
        size,
        'title'
      );
    } else {
        articlesDocs = await firebaseUtility.GetNextPageAllDocuments(
        'support_articles',
        size,
        'title'
      );
    }
    setArticles(articlesDocs);
    setFirstItem(articlesDocs[0]);
    setLastItem(articlesDocs[articlesDocs.length - 1]);
    setLoading(false);
  };

  const handlePageSizeChange = async (size) => {
    setLoading(true);
    if (pageSize != size) {
      setPageSize(size);
      await getArticles(false, size);
    }
    setLoading(false);
  };

  const handlePageChange = async (pageIndex) => {
    setLoading(true);
    if (pageIndex < page) {
      await getArticles(true);
    } else {
      await getArticles(false);
    }
    setPage(pageIndex);
    setLoading(false);
  };

  return (
    <Page className={classes.root} title="Supprot Articles">
      <Container maxWidth={false}>
        <Box mt={3}>
          <Results
            pageIndex={page}
            articles={articles}
            isLoading={loading}
            pageSizeIndex={pageSize}
            setPageSize={(size) => {
              handlePageSizeChange(size);
            }}
            pageChanged={(pageIndex) => {
              handlePageChange(pageIndex);
            }}
          />
        </Box>
      </Container>
    </Page>
  );
};

export default Support;
